(function(app, $) {
    var $cache = {},
        markers = [],
        marker,
        point,
        map,
        bounds;

    function initializeCache() {
        $cache.body = $('body.page_content');
        $cache.window = $(window);
        $cache.shops = $cache.body.find('div.shops div.shop-container div.shop-infos-container');
        $cache.map = $cache.body.find('#map');
    }

    function initializeEvents() {
        $cache.window.on('load', function() {
            if($cache.map.length > 0) {
                var mapOptions = {
                    disableDefaultUI : false,
                    scrollwheel      : false
                };

                map = new google.maps.Map(document.getElementById('map'), mapOptions);
                bounds = new google.maps.LatLngBounds();
                var image = new google.maps.MarkerImage('/images/icn-shop.png', new google.maps.Size(42, 65));
                var i = 0;

                $cache.shops.each(function() {
                    var $self = $(this);
                    var latitude = parseFloat($self.attr('data-latitude'));
                    var longitude = parseFloat($self.attr('data-longitude'));

                    point = new google.maps.LatLng(latitude, longitude);

                    marker = new google.maps.Marker({
                        icon      : image,
                        map       : map,
                        position  : point,
                        animation : google.maps.Animation.DROP
                    });
                    markers.push(marker);
                    bounds.extend(marker.position);

                    google.maps.event.addListener(marker, 'click', (function(i) {
                        return function() {
                            $cache.shops.removeClass('active');
                            $cache.shops.eq(i).addClass('active');

                            if(app.device.isMobile) {
                                $("html, body").animate({
                                    scrollTop : $cache.shops.eq(i).offset().top
                                }, app.preferences.contactTiming / 2);
                            }

                            setTimeout(function() {
                                $cache.shops.removeClass('active');
                            }, app.preferences.contactTiming);
                        }
                    })(i));

                    i++;
                });

                centerMap();
            }
        });

        var timeoutResize;
        $cache.window.resize(function() {
            if(typeof timeoutResize !== 'undefined') {
                clearTimeout(timeoutResize);
            }
            timeoutResize = setTimeout(function() {
                centerMap();
            }, 50);

        });

        $cache.shops.on('click', function() {
            var index = $(this).parent().index();
            markers[ index ].setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function() {
                markers[ index ].setAnimation(null);
            }, app.preferences.contactTiming);
        });
    }

    function centerMap() {
        if(map) {
            map.fitBounds(bounds);
        }
    }

    app.components = app.components || {};
    app.components.contact = {
        init : function() {
            initializeCache();
            initializeEvents();
        }
    };
}(window.app = window.app || {}, jQuery));
